import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab } from '@mui/material';
import { useSelector } from 'react-redux';
import URL2 from '../config.js';

const AIC_DIALOGUE_NUM = process.env.REACT_APP_AIC_DIALOGUE_NUM;

const WhatsAppWidget = ({ text }) => {
    const { ParentID } = useSelector((state) => state.auth);
    const whatsappLink = `https://api.whatsapp.com/send?phone=${AIC_DIALOGUE_NUM}&text=${text}`;

    const handleClick = async () => {
        const payload = {
            ParentID: ParentID
        };
        await URL2.post('/logs/whatsapp-log', payload);
        window.open(whatsappLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <Fab
            onClick={handleClick}
            color="success"
            aria-label="whatsapp"
            sx={{
                position: 'fixed',
                bottom: { xs: 88, sm: 24 }, // elevated on mobile to float cleanly above sticky bottom bar
                right: { xs: 16, sm: 24 },
                zIndex: 1200, // higher zIndex to stay accessible on mobile
                backgroundColor: '#25D366',
                color: 'white',
                boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                '&:hover': {
                    backgroundColor: '#1ebe5d',
                },
            }}
        >
            <WhatsAppIcon />
        </Fab>
    );
};

export default WhatsAppWidget;
